import { render, staticRenderFns } from "./ObligationToBuild.vue?vue&type=template&id=6166131c&"
import script from "./ObligationToBuild.vue?vue&type=script&lang=ts&"
export * from "./ObligationToBuild.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports